"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importStar(require("react"));
const graphql_1 = require("../../../graphql");
const react_hooks_1 = require("@apollo/react-hooks");
const template_parser_1 = require("@osmosys/template-parser");
const lodash_1 = require("lodash");
const react_use_1 = require("react-use");
const use_debounce_1 = require("use-debounce");
const hooks_1 = require("../hooks");
const hooks_2 = require("../../../hooks");
const diffFields = [
    'blocks',
    'html',
    'defaultContentFeedSecond',
    'emailTemplateVersion',
    'name',
];
exports.EmailCanvasSaveButton = () => {
    const { prefs: { view }, state: { draftEmail, sourceEmail }, } = hooks_1.useEmailCanvasContext();
    const [disable, toggleDisabled] = react_use_1.useToggle(false);
    const [hasChanges, toggleHasChanges] = react_use_1.useToggle(false);
    const [checkIfChanged] = use_debounce_1.useDebouncedCallback(() => {
        toggleDisabled(false);
        if (!draftEmail || !sourceEmail) {
            if (hasChanges) {
                toggleHasChanges(false);
            }
            return;
        }
        const compare = {
            draft: lodash_1.pick(draftEmail, diffFields),
            source: lodash_1.pick(sourceEmail, diffFields),
        };
        // If the draft is equal, don't get the variables for the mutation
        const draftIsEqual = lodash_1.isEqual(compare.draft, compare.source);
        if (!draftIsEqual !== hasChanges) {
            toggleHasChanges(!draftIsEqual);
        }
    }, 500, {
        maxWait: 1000,
    });
    react_2.useEffect(() => () => {
        toggleDisabled(true);
        checkIfChanged();
    }, [
        draftEmail.blocks,
        draftEmail.html,
        draftEmail.defaultContentFeedSecond,
        draftEmail.emailTemplateVersion,
        draftEmail.name,
        sourceEmail,
    ]);
    if (view === 'send') {
        return (react_2.default.createElement(EmailCanvasSaveButtonEditEmail, { emailNumber: draftEmail.emailNumber }));
    }
    if (hasChanges) {
        return react_2.default.createElement(EmailCanvasSaveButtonHasChanges, null);
    }
    return (react_2.default.createElement(EmailCanvasSaveButtonNoChanges, { view: view, emailNumber: draftEmail.emailNumber, disable: disable }));
};
const EmailCanvasSaveButtonNoChanges = ({ view, emailNumber, disable }) => {
    return (react_2.default.createElement(EmailCanvasSaveButtonNoChangesInner, { view: view, emailNumber: emailNumber, disable: disable }));
};
const EmailCanvasSaveButtonEditEmail = ({ emailNumber }) => {
    return react_2.default.createElement(EmailCanvasSaveButtonEditEmailInner, { emailNumber: emailNumber });
};
const EmailCanvasSaveButtonEditEmailInner = ({ emailNumber }) => {
    const { state: { disableEditEmailButtonOnCampaignSendPageButton }, } = hooks_1.useEmailCanvasContext();
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: "EmailCanvasSaveButton", osysStyle: "default", replace: true, color: "dark", margin: true, disabled: disableEditEmailButtonOnCampaignSendPageButton, to: `/emails/${emailNumber}`, iconSpin: disableEditEmailButtonOnCampaignSendPageButton, osysIcon: disableEditEmailButtonOnCampaignSendPageButton ? 'spinner' : 'arrowLeft', iconPosition: "left", iconStyle: "solid" }, disableEditEmailButtonOnCampaignSendPageButton
        ? 'Updating'
        : 'Edit email'));
};
const EmailCanvasSaveButtonNoChangesInner = ({ view, emailNumber, disable, }) => {
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: "EmailCanvasSaveButton", osysStyle: "default", replace: true, color: view === 'send' ? 'dark' : 'primary', margin: true, disabled: disable, to: view === 'send'
            ? `/emails/${emailNumber}`
            : `/emails/${emailNumber}/send`, osysIcon: view === 'send' ? 'arrowLeft' : 'arrowRight', iconPosition: view === 'send' ? 'left' : 'right', iconStyle: "solid" }, view === 'send' ? 'Edit email' : 'Send test email'));
};
const EmailCanvasSaveButtonHasChanges = () => {
    const { state: { draftEmail, sourceEmail }, } = hooks_1.useEmailCanvasContext();
    const { dispatchCanvasAction } = hooks_1.useEmailCanvasUpdate();
    const { appSettings: { featureFlagOverrides: { useNewLoaderForEmailQuery }, }, } = hooks_2.useOsmosysContext();
    const [save, saveResult] = react_hooks_1.useMutation(graphql_1.createOrUpdateEmail, {
        onCompleted: ({ createOrUpdateEmail }) => {
            dispatchCanvasAction({
                data: {
                    draftEmail: Object.assign({}, createOrUpdateEmail),
                    sourceEmail: Object.assign({}, createOrUpdateEmail),
                },
                type: 'state',
            });
        },
    });
    const onSave = react_2.useCallback(() => {
        save({
            variables: Object.assign({ useNewLoaderFeature: useNewLoaderForEmailQuery }, template_parser_1.getMutationVariablesForBlocks(sourceEmail.id, draftEmail.blocks, draftEmail.html, draftEmail.defaultContentFeedSecond, draftEmail.emailTemplateVersion)),
        });
    }, [
        useNewLoaderForEmailQuery,
        sourceEmail.id,
        draftEmail.blocks,
        draftEmail.html,
        draftEmail.defaultContentFeedSecond,
        draftEmail.emailTemplateVersion,
    ]);
    return (react_2.default.createElement(EmailCanvasSaveButtonHasChangesInner, { saveResult: saveResult, onSave: onSave }));
};
const EmailCanvasSaveButtonHasChangesInner = ({ saveResult, onSave }) => {
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: "EmailCanvasSaveButton", osysStyle: "default", color: "success", margin: true, mutate: onSave, renderApolloError: true, mutationResult: saveResult, osysIcon: "arrowRight", iconPosition: "right", iconStyle: "solid" }, "Save changes"));
};
//# sourceMappingURL=SaveButton.js.map